import React, { useEffect, useState } from "react";
import { Editor, Toolbar } from "@wangeditor/editor-for-react";
import "@wangeditor/editor/dist/css/style.css";

export default function MyEditor({ onChange, value, disabled }) {
  const [editor, setEditor] = useState(null);
  const [html, setHtml] = useState("");

  useEffect(() => {
    setHtml(value);
  }, [value]);

  return (
    <div style={{ border: "1px solid #ccc" }}>
      <Toolbar editor={editor} mode="default" />
      <Editor
        defaultConfig={{
          placeholder: "请输入内容...",
          readOnly: disabled,
        }}
        value={html}
        onCreated={setEditor}
        onChange={(editor) => {
          setHtml(editor.getHtml());
          onChange(editor.getHtml());
        }}
        mode="default"
        style={{ height: "300px" }}
      />
    </div>
  );
}
